<template>
  <div>
    <a-modal
      :title="audit ? '用印审批' : '用印申请详情'"
      :visible="is_show"
      width="60%"
      @cancel="is_show = false"
      :maskClosable="false"
      class="gufiiguy"
    >
      <template slot="footer">
        <a-button key="back" @click="is_show = false"> 取消 </a-button>
        <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
        <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
        <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
      </template>
      <div ref="sadsada">
        <a-form-model :model="info" :label-col="labelCol3" :wrapper-col="wrapperCol3">
          <div class="title">
            <span>基本信息</span>
          </div>
          <div class="content">
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="审批标题"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.title }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="审批编号"
                  class="model_span_form"
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                >
                  <span>{{ info.applyCode }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  label="抄送人"
                  class="model_span_form"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                >
                  <span>{{ info.ccName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="用印部门" class="model_span_form">
                  <span>{{ info.subjectionDeptName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="用印人" class="model_span_form">
                  <span>{{ info.sealUserName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="申请时间" class="model_span_form">
                  <span>{{ info.createTime }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
                <a-col :span="8">
                <a-form-model-item label="用印日期" class="model_span_form">
                  <span>{{ info.stampDate }}</span>
                </a-form-model-item>
              </a-col>
           
              <a-col :span="8">
                <a-form-model-item label="文件份数" class="model_span_form">
                  <span>{{ info.documentNum }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="文件类别" class="model_span_form">
                  <span>{{ info.documentTypeName }}</span>
                </a-form-model-item>
              </a-col>
               </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="加盖何种印章" class="model_span_form">
                  <span>{{ info.sealTypeName }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  label="用印文件名称"
                  class="model_span_form"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                >
                  <span>{{ info.document }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="备注" class="model_span_form" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <span>{{ info.remark }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="图片" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <div
                    class="view_path_img"
                    v-for="(item, index) in info.vouchers"
                    :key="index"
                    style="display: flex; justify-content: space-between"
                  >
                    <div class="view_path_img_margin"></div>
                    <div class="view_path_img_center">
                      <img :src="item.imgUrl" @click="show_img(index, info.vouchers)" />
                    </div>
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="附件" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                  <div
                    class="view_path"
                    @click="previewFile(item)"
                    v-for="(item, index) in info.attachment"
                    :key="index"
                  >
                    {{ item.name }}
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
          <div class="title" v-if="!audit && recordNumber==1">
            <span>审批记录</span>
          </div>
          <div class="content" v-if="!audit && recordNumber==1">
            <auditModel ref="auditModel"></auditModel>
          </div>
        </a-form-model>
      </div>
    </a-modal>
    <!-- 撤销提示 -->
    <preview ref="preview" />
    <a-modal
      v-model="is_revocation"
      :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
      on-ok="handleOkReason"
    >
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="comment" />
    </a-modal>
    <transferModal ref="transferModal" @sure="handleSure" />
  </div>
</template>
<script>
import auditModel from './audit.vue'
import { previewFileLists } from '@/utils/preview.js'
import { resolveBlob } from '@/utils/index'
import { download_file_java } from '@/utils/request'
import { seal_apply_get } from '@/api/financial'
import { getClaimByBusiness, act_task_audit } from '@/api/activiti'
import { act_sku_num } from '@/api/assetmenag'
import { checkPermission } from '@/utils/permissions'
import preview from '@/components/module/prview'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import Watermark from '../../../utils/watermark'
export default {
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    preview,
    transferModal,
    auditModel
  },
  data() {
    return {
      recordNumber: 0,
      is_revocation: false,
      result: '',
      comment: '', //驳回原因
      is_show: false,
      info: {},
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 16,
      },
      labelCol3: {
        span: 9,
      },
      wrapperCol3: {
        span: 15,
      },
      record: null,
      assetsExportConsumables: checkPermission('asset:claim:checkSku'),
    }
  },
  activated() {},
  watch: {},
  created() {},
  mounted() {
    console.log(this.assetsExportConsumables)
  },
  methods: {
    handleSure() {
      this.is_show = false
      this.$emit('ok')
    },
    //预览文件
    async previewFile(file) {
      let path = '/' + file.url.split('/')[0] + '/'
      let fileName = file.url.substring(file.url.indexOf('/') + 1)
      var res = await download_file_java(file.types, path, fileName)
      var file_s_n = file.name.split('.')
      let type = file_s_n[file_s_n.length - 1]
      resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
    },
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      this.$refs.preview.show(row)
    },
    show(record, type = null) {
      this.recordNumber = record.recordNumber
      this.record = record
      seal_apply_get(record.businessKey).then((res) => {
        console.log(res)
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.info = res.data
        previewFileLists(this.info.vouchers).then((res) => {
          this.info.vouchers = res
        })
        this.is_show = true
        this.$nextTick(() => {
          Watermark.set('安联云管家', this.$refs.sadsada)
           if(!this.audit && this.recordNumber == 1) {
                 this.$refs.auditModel.show(record)
               }
        })
      })
    },
    //驳回
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else {
        this.is_revocation = true
        this.comment = ''
        this.result = result_
      }
    },
    handleOkReason() {
      if (this.result == 3) {
        if (this.comment == '') {
          this.$message.error('请输入驳回意见！')
        } else {
          this.succeed(this.result)
        }
      } else if (this.result == 2) {
        this.succeed(this.result)
      }
    },
    //审批
    succeed(result_) {
      act_task_audit({
        taskId: this.record.id,
        procDefKey: this.record.processDefKey,
        procInstId: this.record.procInstId,
        procName: this.record.processName,
        applyer: this.record.applyer,
        result: result_,
        businessKey: this.record.businessKey,
        comment: this.comment,
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('审批成功')
        this.$emit('ok')
        this.is_show = false
        this.is_revocation = false
      })
    },
  },
}
</script>
<style>
</style>
